/* AM: barra fina bajo las listas de productos deslizables (móvil/tablet) y bajo cualquier lista con data-am-barra
   (p. ej. las colecciones de AM - Portada).
   El pulgar muestra qué parte de la lista se ve; se puede tocar o arrastrar para moverla. */
(function () {
  function crearBarra(lista) {
    if (lista.dataset.amBarra) return;
    // Productos relacionados llegan por fetch y su script en línea no se ejecuta: el sorteo se hace aquí
    if (lista.dataset.amAleatorio && window.amAleatorio) window.amAleatorio(lista);
    lista.dataset.amBarra = '1';

    var barra = document.createElement('div');
    barra.className = 'am-barra';
    barra.setAttribute('aria-hidden', 'true');
    var pulgar = document.createElement('div');
    pulgar.className = 'am-barra__pulgar';
    barra.appendChild(pulgar);

    // Detrás de los botones: Dawn los oculta en ordenador con ".slider--tablet + .slider-buttons",
    // así que tienen que seguir pegados a la lista
    var botones = lista.parentNode.querySelector(':scope > .slider-buttons');
    var ancla = botones || lista;
    ancla.parentNode.insertBefore(barra, ancla.nextSibling);

    function pintar() {
      var total = lista.scrollWidth;
      var visible = lista.clientWidth;
      if (!total || !visible) return;
      if (total - visible < 2) {
        barra.hidden = true;
        return;
      }
      barra.hidden = false;
      var ancho = barra.clientWidth;
      var anchoPulgar = Math.max(ancho * (visible / total), 30);
      var avance = lista.scrollLeft / (total - visible);
      pulgar.style.width = anchoPulgar + 'px';
      pulgar.style.transform = 'translateX(' + avance * (ancho - anchoPulgar) + 'px)';
    }

    var arrastrando = false;
    var desfase = 0;

    function moverA(clientX) {
      var r = barra.getBoundingClientRect();
      var anchoPulgar = pulgar.offsetWidth;
      var x = clientX - r.left - desfase;
      var avance = Math.min(Math.max(x / (r.width - anchoPulgar), 0), 1);
      lista.scrollLeft = avance * (lista.scrollWidth - lista.clientWidth);
      pintar();
    }

    barra.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      var rp = pulgar.getBoundingClientRect();
      // Si se toca el pulgar se arrastra desde ese punto; si se toca la pista, el pulgar se centra en el dedo
      desfase = e.clientX >= rp.left && e.clientX <= rp.right ? e.clientX - rp.left : pulgar.offsetWidth / 2;
      lista.style.scrollSnapType = 'none';
      lista.style.scrollBehavior = 'auto';
      barra.classList.add('is-arrastrando');
      barra.setPointerCapture(e.pointerId);
      moverA(e.clientX);
    });
    barra.addEventListener('pointermove', function (e) {
      if (arrastrando) moverA(e.clientX);
    });
    function soltar() {
      if (!arrastrando) return;
      arrastrando = false;
      barra.classList.remove('is-arrastrando');
      lista.style.scrollSnapType = '';
      lista.style.scrollBehavior = '';
    }
    barra.addEventListener('pointerup', soltar);
    barra.addEventListener('pointercancel', soltar);

    lista.addEventListener('scroll', pintar, { passive: true });
    window.addEventListener('resize', pintar);
    pintar();
    // Las fotos pueden cambiar el ancho al cargar
    lista.addEventListener('load', pintar, true);
  }

  function buscar(raiz) {
    (raiz || document).querySelectorAll('.product-grid.slider, [data-am-barra]').forEach(crearBarra);
  }

  function iniciar() {
    buscar();
    // "Productos relacionados" se carga después, por fetch
    new MutationObserver(function (cambios) {
      cambios.forEach(function (c) {
        c.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) {
            if (n.matches && n.matches('.product-grid.slider, [data-am-barra]')) crearBarra(n);
            else if (n.querySelectorAll) buscar(n);
            // Listas aleatorias sin deslizador (p. ej. en ordenador)
            if (n.querySelectorAll && window.amAleatorio) {
              n.querySelectorAll('[data-am-aleatorio]').forEach(window.amAleatorio);
            }
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
